import { AuthenticatedTemplate } from '@azure/msal-react';
import './NotFoundPage.scss'

const NotFoundPage = () => {
    return <AuthenticatedTemplate>
        <div className="general-page-container">
                <div className="not-found-inner-wrap">
                    <div className="not-found-number">404. Oops...</div>
                    <div className="not-found-label">La pagina che stai cercando risulta essere stata modificata, eliminata o inesistente.</div>
                </div>
            </div>;
    </AuthenticatedTemplate>
    
}

export default NotFoundPage;